export const OFFICE_CARDS_TYPE = {
  OFFICE_CARDS_ALWAYS: 'OFFICE_CARDS_ALWAYS',
  OFFICE_CARDS_WITHOUT: 'OFFICE_CARDS_WITHOUT',
  OFFICE_CARDS_OPTIONAL: 'OFFICE_CARDS_OPTIONAL'
}
